import { z } from "zod";
import { localStore } from "../../../lib/store";

const postLoginRedirectPathStore = localStore<string | null>(
  "authRedirectPath",
  null,
  z.string().nullable()
);

export function getPostLoginRedirectPath() {
  const path = postLoginRedirectPathStore.get();
  return path === null ? "" : path;
}

export function memorizePostLoginRedirectPath() {
  if (globalThis.location.pathname.startsWith("/login")) return;
  postLoginRedirectPathStore.set(
    globalThis.location.pathname + globalThis.location.search
  );
}

/**
 * Memorize a destination that is not the current page: the login detour into
 * onboarding carries its chosen destination this way (`loginAndRedirect`).
 */
export function memorizePostLoginRedirectTo(path: string) {
  postLoginRedirectPathStore.set(path);
}

export function clearPostLoginRedirectPath() {
  postLoginRedirectPathStore.set(null);
}
